export const SIGNED_TRANSACTION = 'signedTraction';
export const MAIL_CONNECT = 'mailConnect';
export const MYALGO_WALLET_CONNECT = 'myAlgoWalletConnect';
export const PERA_WALLET_CONNECT = 'peraWalletConnect';
export const BTN_BUY_ZONE = 'btnClick/buyZone';
export const BTN_SIGN_OUT = 'btnClick/signOut';
export const BTN_SIGN_IN = 'btnClick/signIn';
export const CONNECT_WALLET_SIGN_IN = 'connectWallet/signIn';
export const BTN_VERIFY = 'btnClick/verify';
export const PLAY_NOW = 'playNow';
export const BTN_CHAT = 'btnClick/chat';
export const DAILY_ACTIVE_USERS = 'dailyActiveUsers';
export const DAILY_ACTIVE_WALLETS = 'dailyActiveWallets';

// Fantasy
export const BTN_FANTASY_PLAY = 'btnClick/fantasyPlay';
export const FANTASY_TRANSATIONS = 'fantasyTransations';
// MarketPlace
export const BTN_BUY_MARKETGIFTCARD = 'btnClick/buyMarketGiftCard';
export const BTN_BUY_MARKETGIFTCARD_ZONE =
  'btnClick/buyMarketGiftCardUsingZone';
export const BTN_BUY_MARKETGIFTCARD_ALGO =
  'btnClick/buyMarketGiftCardUsingAlgo';
export const BTN_BUY_MARKETGIFTCARD_BNB = 'btnClick/buyMarketGiftCardUsingBNB';
export const MARKET_VOUCHER_SELECT = 'marketVoucherSelect';
export const BTN_FINAL_BUY_MARKETGIFTCARD = 'btnClick/marketFinalBuy';
export const MARKETPLACE_PROGRAMMATIC_SEO_PAGE_VISITED =
  'pageView/marketPlaceProgrammaticSEOPage';
// Pools
export const BTN_FREE_ACQUISITION_POOL = 'btnClick/freeAquisitionPool';
export const BTN_FREE_POOL = 'btnClick/freePool';
export const PAID_POOL_EVENT = 'btnClick/paidPool';
export const PVP_CHALLENGE_BTN_EVENT = 'btnClick/pvpChallenge';
export const PVP_POOL_PLAY_NOW = 'btnClick/pvpPoolPlayNow';
export const BTN_PAID_PVP_POOL = 'btnClick/paidpvpPool';
export const BTN_FREE_PVP_POOL = 'btnClick/freepvpPool';
export const BTN_POOL = 'btnClick/pool';
export const BTN_LADDER_POOL = 'btnClick/ladderPool';
export const BTN_INVITE_POOL = 'btnClick/invitePool';
export const BTN_INVITE_POOL_TWITTER = 'btnClick/invitePoolTwitter';
// Blog Page

export const BLOG_PAGE_VIEW = 'pageView/blog';
export const CLICK_CONTINUE_READING = 'btnClick/blogContinueReading';
export const POST_PAGE_VEIW = 'pageView/blogPost';
export const CLICK_POST_PAGE_LINK = 'btnClick/blogPostLink';

// Just Play reward popup

export const REWARD_TWITTER_SHARING = 'btnClick/twitterSharing';

// profile
export const COPY_REFERRAL_LINK = 'btnClick/copiedReferralLink';
export const REFERRAL_TAB_VISITED = 'pageView/ReferralTab';
export const REDEEM_BONUS = 'btnClick/redeemBonus';
export const REFERRAL_INFO_VIEWED = 'btnClick/referralInfoViewed';

// transactions
export const ERROR_TRANSACTION = 'error/transaction';
export const SUCCESS_TRANSACTION = 'btnClick/successfullPayment';

// optedIn
export const OPTEDIN = 'btnClick/optedIn';

// notifications
export const BTN_CLEAR_ALL_NOTIFICATIONS = 'btnClick/clearAllNotifications';

export const BTN_OPEN_USER_PROFILE = 'btnClick/openUserProfile';

// GameZop Message

export const GAMEZOP_MESSAGE_MATCH_FOUND = 'message/gamezopMatchFound';
export const GAMEZOP_MESSAGE_MATCH_START = 'message/gamezopMatchStart';
export const GAMEZOP_MESSAGE_MATCH_NOT_FOUND = 'message/gamezopMatchNotFound';
